module.exports = __webpack_public_path__ + "media/vectors/term-bg-3-e90b58c3.jpg";